export class errorClass{
    constructor(public ExceptionMessage?: string,
        public ExceptionURL?: string,
        public ExceptionType?: any,
        public ExceptionStatus?: any,
        ) {}
}